import { Checkbox, Tooltip } from '@mui/joy';
import { SxProps } from '@mui/material';
import { KeyboardEvent } from 'react';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

interface IProps {
  control?: Control<FieldValues, object>;
  errors?: FieldErrors;
  name?: string;
  disabled?: boolean;
  label?: string | string[] | JSX.Element;
  onChange?: (event: KeyboardEvent<HTMLInputElement>) => void;
  value?: boolean;
  sx?: SxProps;
  disabledTooltip?: string;
}

const CheckboxInputView = ({ value = false, disabled, disabledTooltip, ...rest }: IProps) => {
  const checkbox = <Checkbox checked={value} disabled={disabled} {...rest} />;

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} placement="top">
        <span>{checkbox}</span>
      </Tooltip>
    );
  }

  return checkbox;
};

export default CheckboxInputView;
